import { render, staticRenderFns } from "./ProblemBlank.vue?vue&type=template&id=ab36a99a&scoped=true&"
import script from "./ProblemBlank.vue?vue&type=script&lang=js&"
export * from "./ProblemBlank.vue?vue&type=script&lang=js&"
import style0 from "./ProblemBlank.vue?vue&type=style&index=0&id=ab36a99a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab36a99a",
  null
  
)

export default component.exports